import styled from 'styled-components';
import { MEDIA_QUERIES, GUTTER_HALF } from '@govuk-react/constants';
import { spacing } from '@govuk-react/lib';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/**
 * Grid Row, to be used as a parent component for GridCol.
 *
 * - https://govuk-react.github.io/govuk-react/?path=/docs/grid-row
 */

var GridRow = styled('div').withConfig({
  displayName: "src__GridRow",
  componentId: "sc-1jwfkx4-0"
})(_defineProperty({
  display: 'flex',
  flexDirection: 'column',
  margin: "0 -".concat(GUTTER_HALF)
}, MEDIA_QUERIES.LARGESCREEN, {
  flexDirection: 'row'
}), spacing.withWhiteSpace());
GridRow.displayName = 'GridRow';

export { GridRow, GridRow as default };
